// extracted by mini-css-extract-plugin
export default {"root":"logoLoadingBlock_root__1qxNa","image":"logoLoadingBlock_image__gQW2a"};